import { createAppAsyncThunk, logger, tap2mineReferralContract } from 'shared';
import { Address } from 'viem';

import { actionTypes } from '../action-types';
import { actions } from '../reducer';

export const getReferralLength = createAppAsyncThunk(
  actionTypes.GET_REFERRALS_LENGTH,
  async (address: Address, { dispatch }) => {
    try {
      const maxLength = await tap2mineReferralContract.read.referrerInfoLength([address]);

      const numericMaxLength = Number(maxLength);

      dispatch(actions.setUserReferralsLength(numericMaxLength));

      return numericMaxLength;
    } catch (error) {
      logger(actionTypes.GET_REFERRALS_LENGTH, error);

      throw error;
    }
  },
);
